import styled from "@emotion/styled";

export const Wrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  gap: 20px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    grid-template-columns: 1fr ${({ showButton }) => !showButton && "320px"};
    gap: 12px;
  }

  @media (max-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    grid-template-columns: 1fr;
  }
`;

export const GridItemLeft = styled.div`
  grid-column: 1 / -1;
  grid-row: 2;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    grid-column: 1 / 2;
    grid-row: 1;
  }
`;

export const GridItemRight = styled.div`
  grid-column: 1 / -1;
  grid-row: 1;
  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    grid-column: 2 / 3;
    grid-row: 1;
  }
`;
